import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { MatTableDataSource } from '@angular/material';
import { CommonNotificationService } from 'src/app/shared/services/common-notification/common-notification.service';
import { ClipboardService } from 'ngx-clipboard';
@Component({
  selector: 'app-branch-data',
  templateUrl: './branch-data.component.html',
  styleUrls: ['./branch-data.component.scss']
})

export class BranchDataComponent implements OnInit {
  branchTableData = [];
  dataSource = new MatTableDataSource(this.branchTableData);
  displayedColumns: string[] = ['name', 'id'];

  constructor(
    private dialogRef: MatDialogRef<BranchDataComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private clipboardService: ClipboardService,
    private commonNotificationService: CommonNotificationService
  ) { }

  ngOnInit() {
    this.dataSource = new MatTableDataSource(this.data.details);
  }

  copyText(text: string) {
    this.clipboardService.copyFromContent(text);
    this.commonNotificationService.showSnackBar('Copied to clipboard!', 'success', 2000);
  }
}
